const systemURL = {
  remoteURL: "https://api.dreamlanguagesug.com/",
  localURL: "http://127.0.0.1:8000/",
};
const currentYear = new Date().getFullYear();
const currentTerm = 1;
// const imgURL = systemURL.localURL;
const imgURL = systemURL.remoteURL;
export default {
  url: imgURL,
  currentYear,
  currentTerm,
};
